// extracted by mini-css-extract-plugin
var _1 = "TopicPostSection-module__animateUploadProgressBarWidth--Av9Bl";
var _2 = "TopicPostSection-module__animatedBackground--rIq1d";
var _3 = "TopicPostSection-module__loadMoreContainer--Kyvkr";
var _4 = "TopicPostSection-module__posts--luPxg";
var _5 = "TopicPostSection-module__titleLink--E3ql8";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "loadMoreContainer", _4 as "posts", _5 as "titleLink" }
